import { ErasmusRegularStudentStatus } from "utils/constants";

const DISCIPLINE_CHANGE_WINDOW_MONTHS = 1;

// The backend allows the change only for an arrived non-BIP student and only within a month of the
// arrival. When the arrival date is missing the check is left to the backend, so a legitimate
// action is never hidden.
export const canChangeDisciplines = userInfo => {
  if (userInfo?.isBip || userInfo?.status !== ErasmusRegularStudentStatus.Arrived) return false;

  if (!userInfo?.arrivalDate) return true;

  const deadline = new Date(userInfo.arrivalDate);
  deadline.setMonth(deadline.getMonth() + DISCIPLINE_CHANGE_WINDOW_MONTHS);

  return new Date() <= deadline;
};
